/**
 * Phase 3 wrapper — basic flexbox layout for headings, paragraphs,
 * containers, dividers. The fallback when no higher phase matches the
 * structured input.
 */

import type { Phase, PhaseInput, PhaseOutput } from "../phase.js";
import { analyzePhase3DocumentDetailed } from "../phase3-render.js";
import type { PdfDocumentPhase3 } from "../phase3-types.js";
import { applyBuiltInFontFallback, isPhase3Document } from "../phase-helpers.js";

export const phase3Layout: Phase = {
  name: "phase3-layout",
  matches(input: PhaseInput): boolean {
    return isPhase3Document(input.document);
  },
  async run(input: PhaseInput): Promise<PhaseOutput> {
    const analysis = await analyzePhase3DocumentDetailed(input.document as PdfDocumentPhase3);
    const defaulted = applyBuiltInFontFallback(
      analysis.pages,
      {},
      input.automaticFallbackFont,
    );
    return {
      pages: defaulted.pages,
      meta: analysis.meta,
      interactive: defaulted.interactive,
    };
  },
};
